export default "__VITE_ASSET__0f97c685__"